import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import Slide from "../../../../src/components/FullWidthImageSlider/Slide";
import ImageCalendar from "../../../../src/content/blog-posts/editing-your-dog-sitter-profile/image1.png";
import Link from 'gatsby-link';
import * as React from 'react';
export default {
  FullWidthImageSlider,
  Slide,
  ImageCalendar,
  Link,
  React
};